"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPlayersListByIds = exports.selectUnknownPlayerIds = exports.selectPlayersByIds = exports.selectPlayers = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const pickBy_1 = __importDefault(require("../../utils/functions/pickBy"));
const values_1 = __importDefault(require("../../utils/functions/values"));
const slice_1 = require("./slice");
const selectPlayers = (state) => state.playersProvider.players.entries || slice_1.initialState.players.entries;
exports.selectPlayers = selectPlayers;
/*
Returns players map {} by provided IDs

Should be used as follows:

const neededPlayersMap = useSelector((state: RootState) => selectPlayersByIds(state, neededPlayersIDs))
 */
const selectPlayersByIds = (state, playersIds) => (0, pickBy_1.default)(state.playersProvider.players.entries, (_, key) => playersIds.map((playerId) => playerId.toString()).includes(key.toString()) // toString() conversion is used tokeep the same data format while comparison
);
exports.selectPlayersByIds = selectPlayersByIds;
const selectUnknownPlayerIds = (state, playersIds) => {
    const players = state.playersProvider.players.entries;
    return playersIds.filter((pId) => players[pId] === undefined);
};
exports.selectUnknownPlayerIds = selectUnknownPlayerIds;
/*
Returns players list [] by provided IDs

Should be used as follows:

const neededPlayersList = useSelector((state: RootState) => selectPlayersByIds(state, neededPlayersIDs))
 */
exports.selectPlayersListByIds = (0, toolkit_1.createSelector)([exports.selectPlayersByIds], (playersByIds) => (0, values_1.default)(playersByIds));
//# sourceMappingURL=selectors.js.map